import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconContainerComponent } from '@enginuity/core/atoms/icon-container/icon-container.component';
import { BadgesComponent } from '@enginuity/core/molecules/badges/badges.component';

@Component({
  selector: 'app-warehouse-dropdown',
  templateUrl: './warehouse-dropdown.component.html',
  styleUrls: ['./warehouse-dropdown.component.scss'],
  imports: [CommonModule, IconContainerComponent, BadgesComponent],
})
export class WarehouseDropdownComponent {
  @Output() onClick = new EventEmitter<object>();
  @Input()
  selecteditems: string = '';

  @Output() selectionChanged = new EventEmitter<string>();
  onItemSelected(selectedValue: string) {
    this.selecteditems = selectedValue;
    this.selectionChanged.emit(selectedValue);
  }
  @Input()
  warehouses: any = [
    {
      icon: 'settings',
      label: 'Zirkapur',
      tagLine: '523 km away',
      status: {
        label: 'All products in stock',
        Type: 'completed',
        IconType: 'no_icon',
      },
    },
    {
      icon: 'subscription',
      label: 'Sant Tepiche Europe',
      tagLine: '523 km away',
      status: {
        label: 'Some products not available',
        Type: 'paused',
        IconType: 'no_icon',
      },
    },
    {
      icon: 'subscription',
      label: 'Sant Tepiche Europe',
      tagLine: '523 km away',
      status: {
        label: 'No products are available',
        Type: 'cancelled',
        IconType: 'no_icon',
      },
    },
  ];
}
